import sumBy from 'lodash/sumBy'

export function formatNumber(number: number, decimals: number) {
  return number.toLocaleString('en-NZ', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}
/**
 * Cast a string (input from the user) into a number. If it comes out as NaN
 * or Infinity, treat it as 0.
 *
 * @param input
 */
export function coerceToNumber(input: unknown) {
  const n = Number(input)
  return Number.isFinite(n) ? n : 0
}

/**
 * use coerceToNumber to transform the array before calculating the sum
 */
export function safeSum(arr: Array<number | string | null | undefined>) {
  return sumBy(arr.map(coerceToNumber))
}

export function formatPercentage(input: number | null, precision = 0): string {
  if (input === null) {
    return ''
  }

  return `${(input * 100).toFixed(precision)}%`
}
